// extracted by mini-css-extract-plugin
module.exports = {"root":"_8b9cbe13","content":"_1858f6cd","info":"_818b33b3","title":"_c763d3c0","description":"_7a3dd1f5","button":"_1c5d8302","businessCart":"_08636080","isMobile":"_8c032cc9"};